"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export function NavTracker() {
  
  const pathname = usePathname();

  // eh executado sempre que ocorre alguma navegacao no site (troca entre paginas/componentes do site)
  useEffect(() => {
    
    if (!pathname) return;

    // chamar a api do backend para regitrar o console.log do navigation que ocorreu
    fetch("/api/log-nav", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pathname }),
    });

  }, [pathname]); // useEffect

  return null;

} // NavTracker
